/**
 * Funciones de utilidad para envíos
 */

/**
 * Genera el ID único de fila para DataGrid
 */
export const generarIdFila = (row) => {
    return `${row.serie}-${row.albaran}-${row.linea ?? ""}`;
};

/**
 * Verifica si un envío tiene estado bloqueado
 */
export const estaEstadoBloqueado = (estado) => {
    return estado === 0 || estado === "0" || estado === -1 || estado === "-1";
};

/**
 * Genera URL de tracking según proveedor
 */
export const generarUrlTracking = (row, ejercicio) => {
    const expedicion = row.expedicionAsigna;
    if (!expedicion) return null;

    if (row.delivery?.asigna) {
        return `${window.env.ASIGNA_URL}${expedicion}`;
    }

    if (row.delivery?.msoft) {
        return `${window.env.MSOFT_URL}?pedido=${encodeURIComponent(expedicion)}&ejercicio=${ejercicio}`;
    }

    return null;
};
